import { useTenants } from '@griegconnect/krakentools-react-kraken-app'
import { ApiServiceProvider } from '../api/ApiServiceProvider'

export const ApiServiceProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const { activeTenant } = useTenants()

  return <ApiServiceProvider tenantRef={activeTenant?.ref}>{children}</ApiServiceProvider>
}
